import { EnvironmentProviders } from "@angular/core";
import { provideStoreDevtools } from "@ngrx/store-devtools";

export function getStoreDevtoolsProviders(): EnvironmentProviders[] {
    return [
        provideStoreDevtools({
            maxAge: 25,
            logOnly: false,
            autoPause: true,
            trace: false,
            traceLimit: 75,
            connectInZone: true,
        }),
    ];
}
